import React from "react";
import LigImage from "../../images/lig/ligLogo.png";
import Classes from './styles/style.module.css'

const LigIcon = () => {
  return <div className={Classes.ligIconContainer}>
    <img src={LigImage} alt="ligIcon"/>
  </div>;
};

export default LigIcon;
